import React from "react";
import { getViewInfo } from "src/common/attrView";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../../utils/getAttrLabelTreeData";
import { FileList } from "./FileList";

export const makeFileListLabel = (params: MakeLabelParams) => {
  const { attribute, labelTreeData } = params;
  const values = getAttrLabelTreeData(attribute, labelTreeData)?.labels;
  const viewInfo = getViewInfo(attribute.viewType);
  return <FileList values={values} viewInfo={viewInfo} />;
};
